import { render } from "./FooterNr2.vue?vue&type=template&id=3f14d1e2&scoped=true"
import script from "./FooterNr2.vue?vue&type=script&lang=js"
export * from "./FooterNr2.vue?vue&type=script&lang=js"

import "./FooterNr2.vue?vue&type=style&index=0&id=3f14d1e2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f14d1e2"]])

export default __exports__